<template>
  <v-navigation-drawer
    :model-value="newActionComponentProps"
    temporary
    location="right"
    width="545"
    class="my-custom-drawer"
  >
    <NewActionsDrawer
      v-if="newActionComponent"
      :currentRepairFile="currentRepairFile"
      :rentalFileId="rentalFileId"
      @closeNewAction="handleCloseNewAction()"
      @openDeliveryClient="handleOpenDeliveryClient()"
      @openEstimateRepairer="handleOpenEstimateRepairer()"
      @openEstimateRepairerDetail="handleOpenEstimateRepairerDetail()"
      @updateCurrentRepairFile="handleUpdateRepairFile()"
      @showUpdateRepairFileStatusModal="handleShowUpdateRepairFileStatusModal()"
      @openRentalWarningModal="handleOpenRentalWarningModal()"
    />
    <DeliveryClient
      v-if="deliveryClientComponent"
      :currentRepairFile="currentRepairFile"
      @cancelDeliveryClient="handleCancelDeliveryClient()"
      @closeDeliveryClient="handleCloseDeliveryClient()"
      @updateCurrentRepairFile="handleUpdateRepairFile()"
    />
    <EstimateRepairer
      v-if="estimateRepairerComponent"
      :currentRepairFile="currentRepairFile"
      @cancelEstimateRepairer="handleCancelEstimateRepairer()"
      @updateCurrentRepairFile="handleUpdateRepairFile()"
      @closeNewAction="handleCloseNewAction()"
    />
  </v-navigation-drawer>
</template>

<script>
import { defineComponent } from 'vue'
import DeliveryClient from '@/components/repair-file-module/folder-lifecycle/navigation-drawer/DeliveryClient.vue'
import NewActionsDrawer from '@/components/repair-file-module/folder-lifecycle/navigation-drawer/NewActionsDrawer.vue'
import EstimateRepairer from '@/components/repair-file-module/folder-lifecycle/navigation-drawer/EstimateRepairer/EstimateRepairer.vue'
import { RepairFile } from '@/models/RepairFile'
import { displayToast, checkPermission } from '@/components/utils/globalFunction'

export default defineComponent({
  components: { EstimateRepairer, NewActionsDrawer, DeliveryClient },
  props: {
    newActionComponentProps: Boolean,
    currentRepairFile: RepairFile,
    rentalFileId: Object
  },
  data() {
    return {
      loading: false,
      error: null,
      newActionComponent: false,
      deliveryClientComponent: false,
      estimateRepairerComponent: false
    }
  },
  unmounted() {
    this.removeFixedMainPosition()
  },
  watch: {
    newActionComponentProps() {
      if (this.newActionComponentProps === true) {
        this.newActionComponent = true
        this.deliveryClientComponent = false
        this.estimateRepairerComponent = false
        const mainElement = document.querySelector('.main')
        if (mainElement) {
          mainElement.style.position = 'fixed'
        }
      } else {
        this.newActionComponent = false
        this.removeFixedMainPosition()
      }
    }
  },
  methods: {
    checkPermission,

    removeFixedMainPosition() {
      const mainElement = document.querySelector('.main')
      if (mainElement) {
        mainElement.style.position = ''
      }
    },
    handleCloseNewAction() {
      this.removeFixedMainPosition()
      this.$emit('close')
    },
    handleOpenDeliveryClient() {
      if (checkPermission(['DISTRIBUTOR_UPDATE_REPAIR_FILE'])) {
        this.newActionComponent = false
        this.deliveryClientComponent = true
      } else {
        displayToast(this.$t('COMMON.NOT_AUTHORIZED_ACTION_MESSAGE'), 'warning')
      }
    },
    handleCancelDeliveryClient() {
      this.newActionComponent = true
      this.deliveryClientComponent = false
    },
    handleCloseDeliveryClient() {
      if (checkPermission(['DISTRIBUTOR_CLOSE_REPAIR_FILE'])) {
        this.removeFixedMainPosition()
        this.$emit('close')
        this.$emit('updateCurrentRepairFile')
        this.$emit('showGuaranteeExtensionBoomerangModal')
      } else {
        displayToast(this.$t('COMMON.NOT_AUTHORIZED_ACTION_MESSAGE'), 'warning')
      }
    },
    handleUpdateRepairFile() {
      this.$emit('updateCurrentRepairFile')
    },
    handleOpenEstimateRepairer() {
      if (checkPermission(['DISTRIBUTOR_UPDATE_REPAIR_FILE'])) {
        this.newActionComponent = false
        this.estimateRepairerComponent = true
      } else {
        displayToast(this.$t('COMMON.NOT_AUTHORIZED_ACTION_MESSAGE'), 'warning')
      }
    },
    handleCancelEstimateRepairer() {
      this.newActionComponent = true
      this.estimateRepairerComponent = false
    },
    async handleOpenEstimateRepairerDetail() {
      if (checkPermission(['DISTRIBUTOR_UPDATE_REPAIR_FILE'])) {
        this.$emit('updateCurrentRepairFile')
        this.newActionComponent = false
        this.estimateRepairerComponent = true
      } else {
        displayToast(this.$t('COMMON.NOT_AUTHORIZED_ACTION_MESSAGE'), 'warning')
      }
    },
    handleShowUpdateRepairFileStatusModal() {
      if (checkPermission(['DISTRIBUTOR_UPDATE_REPAIR_FILE'])) {
        this.$emit('showUpdateRepairFileStatusModal')
      } else {
        displayToast(this.$t('COMMON.NOT_AUTHORIZED_ACTION_MESSAGE'), 'warning')
      }
    },
    handleOpenRentalWarningModal() {
      if (checkPermission(['DISTRIBUTOR_RENTAL_CREATE'])) {
        this.$emit('openRentalWarningModal')
      } else {
        displayToast(this.$t('COMMON.NOT_AUTHORIZED_ACTION_MESSAGE'), 'warning')
      }
    }
  }
})
</script>
